import { Form, Input, InputNumber, Switch, Col, Row, Select } from 'antd';
import { useEffect, useRef, useState, useContext } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import fetchApi from '../../../utils/api/fetchApi';
import { SocketContext } from '../../../App';

export default function MenuIconEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    const [iconData, setIconData] = useState<any>();

    const position = [
        {
            value: 'before',
            label: '前面'
            // disabled: true,
        },
        {
            value: 'after',
            label: '后面'
            // disabled: true,
        },
    ];

    /** 后端数据wmService */
    let wmService: any = '';

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;

            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {

                }
            })
        }

        const fetchData = async () => {
            form.setFieldsValue({ targetId: data.sendPageData.targetId });
            form.setFieldsValue({ targetKey: data.sendPageData.targetKey });
            form.setFieldsValue({ branchStoreId: contextData?.currentBranchStoreId });

            fetchApi.GET(wmService, {
                apiId: "icon",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setNewData(res.data, setIconData);
                }
            })
        }
        fetchData()
    }, [])

    const setNewData = async (rows: any, setData: any) => {
        let newDatas: Array<any> = [];
        for (var j = 0; j < rows.length; j++) {
            newDatas.push({
                value: rows[j].id,
                label: (
                    //src是文本
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {rows[j].iconSrc}&nbsp;&nbsp;{rows[j].iconName}
                    </div>

                    //src是图片地址
                    //     <div style={{ display: 'flex', alignItems: 'center' }}>
                    //     <img
                    //         src={rows[j].iconSrc}
                    //         alt={rows[j].iconName}
                    //         style={{
                    //             width: 20,
                    //             height: 20,
                    //             marginRight: 8,
                    //             borderRadius: '50%'
                    //         }}
                    //     />
                    //     {rows[j].iconName}
                    // </div>
                )
            })
        }
        setData(newDatas);
    }

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'menuIcon'
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '菜式图标'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    form={form}
                    initialValues={{ "sortBy": 999, "amount": 1 }}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="门店Id"
                                name="branchStoreId"
                            >
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="目标ID"
                                name="targetId">
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="使用位置"
                                name="targetKey">
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="图标"
                                name="iconId"
                                rules={[{ required: true, message: '请选择图标!' }]}>
                                <Select
                                    showSearch
                                    placeholder="选择图标"
                                    optionFilterProp="children"
                                    options={iconData}
                                >
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="显示位置"
                                name="position"
                                rules={[{ required: true, message: '请选择显示位置!' }]}>
                                <Select
                                    showSearch
                                    placeholder="选择显示位置"
                                    optionFilterProp="children"
                                    options={position}
                                />

                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="数量"
                                name="amount">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}